import styled from 'styled-components';

import EditImageView from '../EditImage';

import { outlineGray } from '../../config/colors';

export const ImageAndLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
  padding-top: 5px;
`;

export const Image = styled(EditImageView).attrs((props) => ({
  containerStyle: {
    width: '100%',
    height: '340px',
  },
}))``;

export const Label = styled.input`
  width: 100%;
  height: 50px;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 15px 10px;
  justify-content: space-between;
  font-size: 1rem;
  text-align: start;
  margin-top: 20px;
  margin-bottom: 50px;
`;
